import styled from 'styled-components';
import Image from 'react-bootstrap/Image';
import { Image as ImageWithMock } from 'modules/core/components';
import { Col, Form, Row } from 'react-bootstrap';
import { modalButtonMixin } from 'modules/core/theme/mixins';
import { Button } from 'modules/core/components/Button/styles';
import { STATIC_IMAGE_URLS } from 'modules/core/constants';
import { DEFAULT_FONT_SIZE } from 'modules/core/theme/typography';
import { Title } from 'components/ModalDialog/style';
import { Tooltip } from 'react-tooltip';

import { FormLabel } from './components/common/Label/styles';
import { COLORS } from '../../../modules/core/theme/colors';
import { TableHeaderCell } from './Table/styles';
import { CheckBox } from './components/common/ConfirmCheckBox/styles';
import { VehiclesDescriptionWrapper } from './components/VehiclesDescription/styles';

export const Img = styled(ImageWithMock)`
  width: 105px;
`;

export const VehiclePhotoBlock = styled.div`
  width: fit-content;
  padding-right: 5px;
`;

export const ImgContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
`;

export const ModalColorBadgeWrapper = styled.div`
  position: absolute;
  top: -6px;
  right: -6px;
`;

export const MonthlyIncomeCol = styled(Col)`
  width: 27%;
  flex: none;
`;

export const ApprovedPaymentCol = styled(Col)`
  width: 30%;
  flex: none;
`;

export const FieldLabel = styled(Form.Label)`
  margin-bottom: 0.2rem;
  font-size: ${DEFAULT_FONT_SIZE};
  color: ${COLORS.GREY_24};
  font-weight: bold;
`;

export const VehiclesDescriptionFields = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  color: ${COLORS.GREY_3};
`;

export const Link = styled.a`
  color: ${({ theme: { colors } }) => colors['blue-4']};
  text-decoration: none;
  cursor: pointer;

  &:hover {
    color: ${({ theme: { colors } }) => colors['blue-4']};
    text-decoration: none;
  }
`;

export const ModalButton = styled(Button)<{ width?: string; padding?: string }>`
  ${modalButtonMixin};
  width: ${({ width }) => (width ? `${width}` : '120px')};
  padding: ${({ padding }) => (padding ? `${padding}` : '12px')};
  ${({ $marginRight }) => $marginRight && `margin-right: ${$marginRight};`};
`;

export const FieldsRow = styled(Row)`
  &:nth-child(2) {
    margin-top: 5px;
    margin-bottom: 5px;
  }

  .dropdown-toggle {
    font-weight: normal !important;
  }

  .col-20 {
    flex: 0 0 20%;
    max-width: 20%;
  }

  & .placeholder {
    order: 200;
    background-color: inherit;
  }
`;

export const FormControlFeedback = styled(Form.Control.Feedback)<{ fontSize?: number; isItalic?: boolean }>`
  font-size: ${({ fontSize }) => (fontSize ? `${fontSize}px !important` : '12px !important')};
  font-weight: normal !important;
  margin-top: 3px;
  font-style: ${({ isItalic }) => isItalic && 'italic'};
  color: ${({ $isInvalid }) => ($isInvalid ? '#dc3545' : COLORS.BLACK_3)} !important;
  z-index: 1;
`;

export const FieldHint = styled.div`
  font-size: 12px;
  margin-top: 3px;
  color: ${COLORS.BLACK_3};
`;

export const WarningFieldHint = styled(FieldHint)`
  color: ${COLORS.ORANGE_5};
`;

export const PanelTitle = styled(Title)<{ $compact?: boolean }>`
  padding-bottom: ${({ $compact }) => ($compact ? '0' : '0.938rem')};
  ${({ $compact }) => $compact && 'margin-bottom: 0;'}
  font-size: 14px;
  width: 100%;
`;

export const TitleContainer = styled.div<{ $isInvalid?: boolean }>`
  display: flex;
  align-items: center;

  ${({ $isInvalid }) =>
    $isInvalid &&
    `
    color: ${COLORS.RED_6};
  `}
`;

export const StepNumber = styled.span`
  background-color: ${COLORS.BLUE_5};
  border-radius: 4px;
  padding: 0 6px;
  margin-right: 6px;
  color: ${COLORS.WHITE};
`;

export const StepName = styled.span`
  font-size: 14px;
  font-weight: 700;
`;

export const StepDescription = styled.span`
  font-size: 12px;
  font-style: italic;
  font-weight: 400;
`;

export const ClearButton = styled.div<{ disabled?: boolean }>`
  display: flex;
  align-items: center;
  margin-left: auto;
  font-size: 13px;
  font-weight: 500;
  color: ${COLORS.BLUE_11};
  cursor: pointer;
  transition: color 0.15s ease-in-out;

  ${({ disabled }) =>
    !disabled &&
    `
    &:hover {
      color: ${COLORS.BLUE_5};
    }
  `}

  ${({ disabled }) =>
    disabled &&
    `
    color: ${COLORS.GREY_35};
    cursor: default;
  `}
`;

export const ActualPaymentInfoTitle = styled.div<{ $isResubmitForPricing?: boolean }>`
  margin-top: 0.375rem;
  font-size: 12px;
  font-style: ${({ $isResubmitForPricing }) => ($isResubmitForPricing ? 'normal' : 'italic')};
  line-height: 14px;
  text-align: justify;
`;

export const PaymentCol = styled(Col)`
  flex: 0 0 40%;
  padding: 0 2.25rem 0 1.375rem;
`;

export const PaymentRow = styled(Row)<{ showBalloonPayment: boolean; $showExtraRow?: boolean }>`
  height: 100%;
  background-color: ${COLORS.GREY_29}80;
  border-radius: 0.375rem;

  /* The clamp fits two rows; a third needs the room or it is cut off. */
  ${({ $showBalloonPayment, $showExtraRow }) => !$showBalloonPayment && !$showExtraRow && `max-height: 64px;`}

  & ${FormLabel} {
    font-weight: normal;
    text-align: right;
  }
`;

export const AvailableDealStructuresBlock = styled.div`
  .table-responsive table {
    margin-bottom: 0;
  }
`;

export const TradeMark = styled.span`
  font-size: 12px;
  margin-right: auto;
`;

export const SuccessSubmitRow = styled(Row)`
  font-size: 24px;
  text-align: center;
  padding: 60px;
`;

export const SuccessSubmitLogo = styled(Image)`
  height: 100px;
  margin: 20px 0 40px 0;
`;

export const LoanVariablesDialogRow = styled(Row)<{ $isPrintView: boolean }>`
  padding: 0 15px;

  & .card {
    padding: 0;
    width: 708px;

    .card-body {
      padding: 10px;
    }
  }

  & .card:not(:last-of-type) {
    margin-bottom: 20px;
  }

  ${({ $isPrintView }) =>
    !$isPrintView &&
    `
      & .card {
        background-color: ${COLORS.WHITE};
        border: 0;
        box-shadow: 0 3px 6px ${COLORS.BLACK}29;
      }

      & .card:not(:last-of-type)::after {
        content: '';
        position: absolute;
        left: 40px;
        bottom: -9px;
        width: 0;
        height: 0;
        border-left: 40px solid transparent;
        border-right: 40px solid transparent;
        border-top: 10px solid ${COLORS.WHITE};
        filter: drop-shadow(0 4px 2px ${COLORS.BLACK}20);
      }
  `}

  ${({ $isPrintView }) =>
    $isPrintView &&
    `      
      ${FieldsRow} span,
      ${TableHeaderCell},
      ${VehiclesDescriptionFields} span,
      ${VehiclesDescriptionWrapper} div.vehicle-description,
      ${VehiclesDescriptionWrapper} div.vehicle-contract-info {
        font-size: 14px;
      }

      ${ActualPaymentInfoTitle} {
        font-size: 11px;
      }

      ${FieldsRow}:nth-child(3) {
        margin-top: 10px;
        margin-bottom: 10px;
      }

      ${FormControlFeedback},
      ${CheckBox} {
        display: none !important;
      }
  `}
`;

export const ModalCloseButton = styled.span`
  background-image: url(${STATIC_IMAGE_URLS.icons.modalCloseIcon});
  cursor: pointer;
  width: 10px;
  height: 10px;
  margin-left: 15px;
`;

export const CloseButton = styled(Button)`
  padding: 5px;
  min-height: auto;
  min-width: auto;
  font-weight: 500;
`;

export const CloseIcon = styled.span`
  display: inline-block;
  background-repeat: no-repeat;
  background-size: contain;
  height: 15px;
  width: 15px;
  background-image: url(${STATIC_IMAGE_URLS.icons.arrowRight});
  vertical-align: middle;
  margin-left: 3px;
`;

export const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  font-size: 12px;
`;

export const HeaderLogo = styled.img`
  height: 25px;
  margin-right: 5px;
`;

export const SubmitMessageCol = styled(Col)`
  margin-right: 60px;
`;

export const SubmitCol = styled(Col)`
  flex: 0 0 20%;
  padding: 0 0.715rem 0 0;

  &,
  & > .col {
    display: flex !important;
    flex-direction: column !important;
    justify-content: flex-end !important;
  }
`;

export const SubmitButton = styled(ModalButton)`
  width: unset !important;
  align-self: flex-end !important;
  margin: 2px 2px 2px auto;
  padding: 0px 5px;
`;

export const AllySubmitBlock = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 8px;
`;

export const AllySubmitRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 12px;

  ${PanelTitle} {
    display: flex;
    align-items: center;
    width: auto;
    flex: 1;
    min-width: 0;
    padding-bottom: 0;
    margin-bottom: 0;
  }

  ${SubmitButton} {
    margin: 2px 0 !important;
  }
`;

export const AllySubmitActions = styled.div`
  display: flex;
  align-items: flex-end;
  flex-shrink: 0;
  gap: 12px;
`;

export const AllyRouteOneUserId = styled.div`
  width: 180px;

  & > .col {
    width: 100%;
    max-width: 100%;
    flex: none;
    padding: 0;
  }
`;

export const SubmitMessage = styled.div<{ isInvalid: boolean }>`
  line-height: 16px;
  margin-bottom: 0.175rem;

  ${({ isInvalid }) =>
    isInvalid &&
    `
      color: ${COLORS.RED_6};
      font-style: italic;
    `}
`;

export const UnlockButton = styled(ModalButton)`
  width: 100%;
  min-height: 22px;
  padding: 0;
  margin-top: 5px;
  font-size: 12px;
  font-weight: 500;
  box-shadow: 0 3px 6px ${COLORS.BLACK}29 !important;
  margin-bottom: 5px;
`;

export const MoreInfoButton = styled.div<{ rotate180?: boolean }>`
  font-weight: 500;
  display: inline;
  cursor: pointer;
  float: right;

  img {
    margin-left: 0.5rem;
    vertical-align: inherit;
    ${({ rotate180 }) =>
      rotate180 &&
      `
      transform: rotate(180deg);
    `}
  }
`;

export const SubmitButtonTooltip = styled(Tooltip)`
  z-index: 3;
  max-width: 250px;
  opacity: 1 !important;
  background-color: ${COLORS.WHITE} !important;
  color: ${COLORS.BLACK} !important;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.25);
  font-weight: 400;
  font-size: 12px;
  padding: 10px;
`;

export const MainContentWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;

  .react-toggle-track {
    width: 33px;
    height: 16px;
  }

  .react-toggle-thumb {
    width: 11px;
    height: 11px;
    border: none;
    left: 3px;
    top: 50%;
    transform: translateY(-50%);
    box-shadow: 0 0 0 0 !important;
  }

  .react-toggle--disabled {
    cursor: default;
  }

  .react-toggle--checked .react-toggle-thumb {
    left: 19px;
  }

  .react-toggle-track,
  .react-toggle:hover .react-toggle-track {
    background-color: ${COLORS.GREY_3};
  }

  .react-toggle--checked .react-toggle-track,
  .react-toggle--checked:hover .react-toggle-track {
    background-color: ${COLORS.BLUE_11};
  }
`;

export const RightSideColumn = styled.div`
  width: 100%;
  margin: 0px 3.5px 0px 0.938rem;
  display: flex;
  flex-direction: column;
`;

export const AdSpaceContainer = styled.div`
  background-color: ${COLORS.WHITE};
  border-radius: 0.375rem;
  box-shadow: 0 3px 6px ${COLORS.BLACK}29;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-height: 380px;
  position: relative;
`;

export const AdSpaceLogo = styled.img`
  width: 100%;
  max-width: 260px;
  height: auto;
  object-fit: contain;
`;

export const AdSpaceLinkOutIconWrapper = styled.div`
  position: absolute;
  top: 5px;
  right: 5px;
  width: 25px;
  height: 25px;
  background-color: rgba(255, 255, 255, 0.75);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.2s ease-in-out;
  pointer-events: none;

  ${AdSpaceContainer}:hover & {
    opacity: 1;
  }
`;

export const AdSpaceLinkOutIcon = styled.img`
  width: 15px;
  height: 15px;
`;

export const FieldDescription = styled.div`
  font-size: 12px;
  margin-bottom: 10px;
`;

export const DecisionNote = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  /* min-width: 0 keeps an over-long note from widening its column and squeezing the inputs. */
  min-width: 0;
  width: max-content;
  align-self: center;
  /* Matches the input box beside it (inputHeight + its 1px borders) so the line sits on its centre. */
  min-height: calc(${({ theme: { variables } }) => variables.inputHeight} + 2px);
  font-size: 12px;
  line-height: 16px;
  white-space: nowrap;
  color: ${COLORS.GREY_3};
`;

export const DecisionNoteIcon = styled.img`
  flex: 0 0 auto;
  width: 14px;
  height: 14px;
  cursor: pointer;
`;

/** Hover popup shared by the decision comments and the unconfirmed Est. Customer Rate dash. */
export const HoverNoteTooltip = styled(Tooltip)`
  z-index: 2000;
  max-width: 340px;
  /* Visible so the arrow (a child of this node) cannot create a stray scrollbar. */
  overflow: visible;
  opacity: 1 !important;
  padding: 10px 12px !important;
  border-radius: 6px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.18);
  background-color: ${COLORS.WHITE} !important;
  color: ${COLORS.GREY_5} !important;
  font-size: 12px;
  font-weight: 400;
  line-height: 17px;
  text-align: left;
  word-wrap: break-word;
  overflow-wrap: break-word;
`;

export const DecisionCommentList = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
  /* Fits the busiest decision Ally sends without scrolling; longer ones scroll. */
  max-height: 340px;
  overflow-y: auto;
`;

export const DecisionComment = styled.li`
  position: relative;
  padding-left: 11px;

  & + & {
    margin-top: 7px;
  }

  &::before {
    content: '';
    position: absolute;
    top: 6px;
    left: 1px;
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background-color: ${COLORS.GREY_3};
  }
`;

export const FormContentVisibility = styled.div<{ $isHidden: boolean }>`
  display: ${({ $isHidden }) => ($isHidden ? 'none' : 'contents')};
`;
